import { PROVIDER_NORMALISATION_MAP } from "./constants.js";

export function normalizeString(input: string): string {
  let s = input.trim();
  s = s.replace(/\s+/g, " ").replace(/ /g, "-");
  s = s.toLowerCase();
  s = s.replace(/^\/+|\/+$/g, "");
  s = s.replace(/\/+/g, "/");
  if (
    (s.startsWith('"') && s.endsWith('"')) ||
    (s.startsWith("'") && s.endsWith("'"))
  ) {
    s = s.slice(1, -1);
  }
  return s;
}

export function normalizeProvider(provider: string | undefined): string | undefined {
  if (provider === undefined || provider === "") return undefined;
  const n = normalizeString(provider);
  return PROVIDER_NORMALISATION_MAP[n] ?? n;
}

export function tokenise(s: string): string[] {
  return s.split(/[-_./]+/).filter(Boolean);
}

export function modelSlug(modelId: string): string {
  const slash = modelId.indexOf("/");
  return slash >= 0 ? modelId.slice(slash + 1) : modelId;
}
